import { Injectable } from "@angular/core";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { IBranchLookupService } from "../IBranchLookupService";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BranchLookupService
  extends BaseLookupService<string, CubiqTS.BranchImpl>
  implements IBranchLookupService
{
  private myBranchMapLowercase: Object = Object.create(null);
  private visiblePrivateBranches: Map<string, CubiqTS.BranchImpl> = new Map<
    string,
    CubiqTS.BranchImpl
  >();
  private completeMapOfBranchCodes: Map<string, CubiqTS.BranchImpl> = new Map<
    string,
    CubiqTS.BranchImpl
  >();
  private privateBranchCodes: Set<string> = new Set<string>();
  private activeBranchCode: string = null;
  private bmarkBranchCodes: Set<string> = new Set<string>();

  constructor() {
    super(CubiqTS.BranchImpl);
  }

  deleteItem(item: CubiqTS.BranchImpl): void {
    super.deleteItem(item);

    if (typeof item.branchId == "string") {
      delete this.myBranchMapLowercase[item.branchId.toLowerCase()];
    }
  }

  mapItem(item: CubiqTS.BranchImpl): void {
    this.mapBranchCodeToCompleteSet(item);
    if (item.privateFg) {
      this.privateBranchCodes.add(item.branchId);

      if (item.branchId != this.activeBranchCode) {
        this.visiblePrivateBranches.set(item.branchId, item);
        return;
      }
    }

    if (item.allowBenchmarkOrdersFg) {
      this.bmarkBranchCodes.add(item.branchId);
    }
    super.mapItem(item);

    this.myBranchMapLowercase[item.branchId.toLowerCase()] = item;
  }

  getItem(id: string): CubiqTS.BranchImpl {
    let branch = super.getItem(id);

    if (!branch) {
      branch = this.visiblePrivateBranches.get(id);
    }

    return branch;
  }

  getItemFromCompleteMap(key: string): CubiqTS.BranchImpl {
    return this.completeMapOfBranchCodes.get(key);
  }

  getItemKey(item: CubiqTS.BranchImpl): string {
    // could be string or numeric id
    return String(item.branchId);
  }

  getBranch(id: string): CubiqTS.BranchImpl {
    // var ccyPair:CurrencyPairImpl
    var branch = this.getItem(id);
    if (!branch) {
      let idLowercase = id.toLowerCase();
      branch = this.myBranchMapLowercase[idLowercase];
    }
    return branch;
  }

  getVisiblePrivateBranch(id: string): CubiqTS.BranchImpl {
    // var ccyPair:CurrencyPairImpl
    var branch = this.getItem(id);
    if (!branch) {
      let idLowercase = id.toLowerCase();
      branch = this.myBranchMapLowercase[idLowercase];
    }
    if (!branch) {
      this.visiblePrivateBranches.get(id);
    }
    return branch;
  }

  getAllBranchCodes(): Array<string> {
    return Array.from((<Map<string, any>>this.myItemMap).keys());
  }

  getCompleteListOfBranchCodes(): Array<string> {
    return Array.from((<Map<string, any>>this.completeMapOfBranchCodes).keys());
  }

  setActiveBranchCode(branchCode: string) {
    this.activeBranchCode = branchCode;
  }

  setVisiblePrivateBranchCodes(branchCodes: Array<string>): void {
    if (branchCodes == null || !Array.isArray(branchCodes)) {
      // oh hai sales users
      return;
    }

    let visiblePrivateBranches = new Map<string, CubiqTS.BranchImpl>();

    for (let branchCode of branchCodes) {
      if (this.visiblePrivateBranches.has(branchCode)) {
        this.visiblePrivateBranches.set(branchCode, this.visiblePrivateBranches.get(branchCode));
      } else {
        this.visiblePrivateBranches.set(branchCode, null);
      }
    }
    this.visiblePrivateBranches = visiblePrivateBranches;
  }

  getVisiblePrivateBranchCodes(): Array<string> {
    // more so visible private branches that user is not a member of
    return Array.from(this.visiblePrivateBranches.keys());
  }

  hasBranchCode(branchCode: string): boolean {
    return this.myItemMap.has(branchCode);
  }

  hasVisiblePrivateBranchCode(branchCode: string): boolean {
    return this.visiblePrivateBranches.has(branchCode);
  }

  hasPrivateBranchCode(branchCode: string): boolean {
    return this.visiblePrivateBranches.has(branchCode) && this.privateBranchCodes.has(branchCode);
  }

  isPrivateBranchCode(branchCode: string): boolean {
    // why does this differ from hasVisiblePrivateBranchCode?
    return this.privateBranchCodes.has(branchCode);
  }

  isBmarkBranchCode(branchCode: string): boolean {
    return this.bmarkBranchCodes.has(branchCode);
  }

  getPrivateBranchCodes(): Array<string> {
    return Array.from(this.privateBranchCodes.keys());
  }

  private mapBranchCodeToCompleteSet(item: CubiqTS.BranchImpl) {
    if (this.completeMapOfBranchCodes.has(this.getItemKey(item))) {
      let oldItem = this.getItemFromCompleteMap(this.getItemKey(item));
      this.deleteItem(oldItem);
    }
    this.completeMapOfBranchCodes.set(this.getItemKey(item), item);
  }
}
